import { FC, useEffect, useRef, useState } from 'react';
import { init } from 'pell';
import { TextField } from '@mui/material';
import styles from './TextEditor.module.scss';
import { useFormikContext } from 'formik';

interface Props {
  disabled?: boolean;
  label: string;
  fieldName: string;
  placeholder?: string;
}

export const TextEditor: FC<Props> = ({ disabled = false, label, fieldName, placeholder = '' }) => {
  const editorRef = useRef(null);
  const formik = useFormikContext();
  const [editor, setEditor] = useState<any>(null);

  useEffect(() => {
    // TODO: fix that the editor is regenerated on react hot-reload
    const editor = init({
      actions: ['bold', 'underline', 'ulist', 'link'],
      element: editorRef.current as any,
      onChange: (html) => {
        formik.setFieldValue(fieldName, html);
      },
      defaultParagraphSeparator: 'p',
    });
    editor.content.innerHTML = formik.getFieldProps(fieldName).value || '';
    if (placeholder) {
      editor.content.dataset.placeholder = placeholder;
    }
    setEditor(editor);
  }, []);

  useEffect(() => {
    if (!editor) return;
    editor.content.contentEditable = !disabled;
  }, [editor, disabled]);

  return (
    <div className={styles['texteditor-wrapper']}>
      <div className={styles['editor']} data-disabled={disabled} ref={editorRef} style={{ whiteSpace: 'pre-wrap' }}></div>
      <TextField
        inputProps={{
          readOnly: true,
        }}
        disabled={disabled}
        className="texteditor-pseudo-textfield"
        margin="normal"
        label={label}
        variant="outlined"
        fullWidth
        multiline
        rows={5}
        InputLabelProps={{
          shrink: true,
        }}
      />
    </div>
  );
};
